import { render } from "./WompiResult.vue?vue&type=template&id=7d3b4a5a&scoped=true"
import script from "./WompiResult.vue?vue&type=script&lang=js"
export * from "./WompiResult.vue?vue&type=script&lang=js"

import "./WompiResult.vue?vue&type=style&index=0&id=7d3b4a5a&scoped=true&lang=css"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d3b4a5a"]])

export default __exports__